import mapboxgl from "mapbox-gl";

import { MapboxConstants } from "../constants";

mapboxgl.accessToken = MapboxConstants.ACCESS_TOKEN;

export default mapboxgl;
